var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 3.53c0 .29238-.1506.56414-.3986.7191L12 13 4.39856 8.2491C4.15062 8.09414 4 7.82238 4 7.53c0-.66605.73263-1.07211 1.29744-.7191L12 11l6.7026-4.1891C19.2674 6.45789 20 6.86395 20 7.53z","fill":"#fff"}));
}

Email.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Email;

Email.default = Email;
